import { observer } from "mobx-react-lite";
import { useState, type FormEvent } from "react";

import { desktop } from "../../desktop.ts";
import { useStores } from "../../stores/RootStore.ts";
import { LlmFields, type LlmSettings } from "../ui/LlmFields.tsx";
import { Button, Card, Muted, Page, Row, Title } from "../ui/primitives.tsx";

export const SettingsPage = observer(function SettingsPage() {
    const { connection, ui } = useStores();
    const { llmUrl, llmKey, llmModel } = connection.settings;
    const [llm, setLlm] = useState<LlmSettings>({ llmUrl, llmKey, llmModel });

    function save(event: FormEvent) {
        event.preventDefault();
        connection.save({ ...connection.settings, ...llm });
        ui.show({ name: "workers" });
    }

    function logOut() {
        connection.logOut();
        ui.show({ name: desktop ? "welcome" : "login" });
    }

    return (
        <Page as="form" onSubmit={save}>
            <Card>
                <Title>LLM</Title>
                <Muted>Workers use this for their agent.</Muted>
                <LlmFields value={llm} onChange={setLlm} />
                <Muted>These settings stay on this device.</Muted>
            </Card>
            <Row>
                <Button $primary type="submit">
                    Save
                </Button>
            </Row>
            <Card>
                <Title>Your mainions</Title>
                <Muted>Logged in to {connection.settings.url}.</Muted>
                <Row>
                    <Button type="button" onClick={logOut}>
                        Log out
                    </Button>
                </Row>
            </Card>
        </Page>
    );
});
